import { render, staticRenderFns } from "./policyInterpretation.vue?vue&type=template&id=5e1d887a&scoped=true"
import script from "./policyInterpretation.vue?vue&type=script&lang=js"
export * from "./policyInterpretation.vue?vue&type=script&lang=js"
import style0 from "./policyInterpretation.vue?vue&type=style&index=0&id=5e1d887a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1d887a",
  null
  
)

export default component.exports